import tagsEscl from '../locales/es-CL/tags.json';
import tagsEsmx from '../locales/es-MX/tags.json';
import tagsEsco from '../locales/es-CO/tags.json';
import tagsEnus from '../locales/en-US/tags.json';

import Multiselect from 'vue-multiselect';
import axios from 'axios';
import showAlert from '@waypoint/vue-alert';

export default {
  name: 'Tags',
  components: {
    Multiselect,
  },
  i18n: {
    messages: {
      'es-CL': {
        tags: tagsEscl,
      },
      'es-MX': {
        tags: tagsEsmx,
      },
      'es-CO': {
        tags: tagsEsco,
      },
      'en-US': {
        tags: tagsEnus,
      },
    },
  },
  data() {
    return {
      dataAccess: null,
      isMainPageBussy: false,
      filter: null,
      tags: [],
      mode: null,
      selectedTag: {
        id: null,
        name: null,
      },
      updatedNameTag: null,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 50, 100],
    };
  },
  async created() {
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      this.setSortedTags(await this.getTags());
    },
    async setSortedTags(tags){
      if(tags && tags.length > 0){
        this.tags = tags.sort((a,b)=> ( b.enabled - a.enabled || a.name.localeCompare(b.name) ));
      }
    },
    async getTags() {
      try {
        this.isMainPageBussy = true;
        const response = await axios.get(`${this.$store.getters.urlAPI}/tag`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          this.isMainPageBussy = false;
          return response.data.data;
        }
      } catch (e) {
        this.isMainPageBussy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('user.error.delete'), 'error');
        return [];
      }
    },
    async insertTag() {
      this.selectedTag.name = this.selectedTag.name.trim();
      if (this.isUnique(this.selectedTag.name) && this.validateTag(this.selectedTag.name)) {
        const body = {
          name: this.selectedTag.name,
        };
        try {
          this.isMainPageBussy = true;
          const response = await axios.post(`${this.$store.getters.urlAPI}/tag`, body, {
            headers: {
              'id-client': this.$store.getters.clientId,
              Authorization: `Bearer ${this.$store.getters.accessToken}`,
            },
          });
          if (response.data.status) {
            this.tags.push(response.data.data);
            this.setSortedTags(this.tags);
            this.isMainPageBussy = false;
            this.emptyData();
            this.closeModal('tag-crud');
          }
        } catch (e) {
          this.isMainPageBussy = false;
          console.log(e);
          this.closeModal('tag-crud');
          showAlert(this.$t('common.modals.errorTitulo'), this.$t('tags.errors.errorBack'), 'error');
        }
      }
    },
    async updateTag() {
      this.isMainPageBussy = true;
      this.selectedTag.name = this.selectedTag.name.trim();
      this.updatedNameTag = this.updatedNameTag.trim();
      console.log('update');
      if (this.selectedTag.name !== this.updatedNameTag) {
        this.selectedTag.name = this.updatedNameTag;
        if (this.isUnique(this.selectedTag.name) && this.validateTag(this.selectedTag.name)) {
          const body = {
            name: this.selectedTag.name,
          };
          try {
            const response = await axios.patch(`${this.$store.getters.urlAPI}/tag/${this.selectedTag.id}`, body, {
              headers: {
                'id-client': this.$store.getters.clientId,
                Authorization: `Bearer ${this.$store.getters.accessToken}`,
              },
            });
            if (response.data.status) {
              const responseTag = response.data.data;
              const updateTag = this.tags.find((tag) => tag.id === responseTag.id);
              updateTag.name = responseTag.name;
              this.setSortedTags(this.tags);
              this.isMainPageBussy = false;
              this.emptyData();
              this.closeModal('tag-crud');
            }
          } catch (e) {
            this.isMainPageBussy = false;
            console.log(e);
            this.closeModal('tag-crud');
            showAlert(this.$t('common.modals.errorTitulo'), this.$t('tags.errors.errorBack'), 'error');
          }
        }
        this.isMainPageBussy = false;
      } else {
        this.closeModal('tag-crud');
        this.isMainPageBussy = false;
      }
    },
    async deleteTag() {
      this.isMainPageBussy = true;
      console.log('delete (disable)');
      try {
        const response = await axios.delete(`${this.$store.getters.urlAPI}/tag/${this.selectedTag.id}`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          const indice = this.tags.findIndex((tag) => tag.id === this.selectedTag.id);
          this.tags[indice].enabled = false;
          const changedTag = this.tags[indice].name;
          await this.setSortedTags(this.tags);
          this.isMainPageBussy = false;
          this.emptyData();
          this.closeModal('confirm-delete');

          showAlert(this.$t('tags.modal.info'), this.$t('tags.modal.message.disabled', {name:changedTag}), 'info');
        }
      } catch (e) {
        this.isMainPageBussy = false;
        console.log(e);
        this.closeModal('confirm-delete');
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('tags.errors.errorBack'), 'error');
      }
    },
    async enableTag(){
      this.isMainPageBussy = true;
      console.log('enable tag');
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/tag/${this.selectedTag.id}/enable`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          this.isMainPageBussy = false;
          const changedTag = this.selectedTag.name;
          showAlert(this.$t('tags.modal.info'), this.$t('tags.modal.message.enabled', {name:changedTag}), 'info');
          return true;
        }
      } catch (e) {
        this.isMainPageBussy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('tags.errors.errorBack'), 'error');
      }

      return false;
    },
    emptyData() {
      this.selectedTag.id = null;
      this.selectedTag.name = null;
    },
    validateTag(name) {
      const regex = /^[a-zA-Z0-9ñÑÁÉÍÓÚáéíóú]+$/;
      if (regex.test(name)) return true;
      showAlert(this.$t('common.modals.errorTitulo'), this.$t('tags.errors.badName'), 'error');
      return false;
    },
    isUnique(name) {
      const tagUsed = this.tags.find((tag) => tag.name.toUpperCase() === name.toUpperCase());
      if (!tagUsed) return true;
      showAlert(this.$t('common.modals.errorTitulo'), this.$t('tags.errors.tagExist'), 'error');
      return false;
    },
    openAddModal() {
      this.mode = 'add';
      this.showModal('tag-crud');
    },
    openEditModal(item) {
      this.mode = 'edit';
      this.selectedTag.id = item.id;
      this.selectedTag.name = item.name;
      this.updatedNameTag = item.name;
      this.showModal('tag-crud');
    },
    openDeleteModal(item) {
      this.selectedTag.id = item.id;
      this.selectedTag.name = item.name;
      this.showModal('confirm-delete');
    },
    async openSwitchModal(item,e){
      this.selectedTag.id = item.id;
      this.selectedTag.name = item.name;
      if(item.enabled){
        e.preventDefault();
        this.showModal('confirm-delete');
      }else{
        const result = await this.enableTag(item);
        if(result) item.enabled = true;
        await this.setSortedTags(this.tags);
        this.emptyData();
      }
    },
    closeModal(id) {
      this.emptyData();
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
  },
  computed: {
    tagFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'name',
          label: this.$t('tags.fields.name'),
          ...common,
        },
        {
          key: 'switch',
          label: this.$t('tags.fields.switch'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('tags.fields.actions'),
          ...common,
        },
      ];
    },
  },
};
